<div *ngIf="isFacilityConfigured">
    <div>
      <div class="page-header">
        <div>
          <p class="page-title">
            {{resourceKeyValue.manageUsers}}
          </p>
          
        </div>
        <div>
          <button class="btn btn-primary float-right" id="btnCreateDevice" (click)="getUserManagementUrl()">
            {{resourceKeyValue.manageUsers}} <i class="icon-new-tab-bold icon"></i></button>
        </div>
      </div>
    </div>
    <div class="form-title  padding-top-1em">
        <p class="margin-bottom-1px"> {{resourceKeyValue.manageUsersPageText}}
        </p>
        <p class="margin-bottom-1px float-left"> {{resourceKeyValue.manageUsersPageText1}} </p>
        <p class="margin-bottom-1px float-left"><b>&nbsp; {{resourceKeyValue.manageUsers}} &nbsp;</b></p>
        <p class="margin-bottom-1px float-left"> {{resourceKeyValue.manageUsersPageText2}}</p>
    </div>
</div>
<div *ngIf="!isFacilityConfigured" class=" container-fluid mt-5 pt-5">
  <div class="row">
    <div class="col">
      <h1 id="notAuthorizedInstruction1-Label">{{lblNotAuthorizedInstruction3}}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <h3 id="notAuthorizedInstruction2-Label">{{lblNotAuthorizedInstruction4}}</h3>
    </div>
  </div>
</div>
